var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReliefIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 303 382",
    style: {
      enableBackground: "new 0 0 303 382"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.asdfwef{fill:#71A850;}\n\t.dsfhfgh{fill:#6EA84F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "asdfwef",
    d: "M86.4,168.7c0,36,29.2,65.1,65.1,65.1c36,0,65.1-29.2,65.1-65.1c0-36-29.2-65.1-65.1-65.1 C115.5,103.6,86.4,132.7,86.4,168.7 M92.1,158.6l9.7,9.7l-9.8,9.9C91,171.7,91,165.1,92.1,158.6 M93.4,184.8l14.5-14.5 c1.1-1.1,1.1-2.9,0-4c0,0,0,0,0,0L93.6,152c1.1-3.7,2.5-7.3,4.2-10.7l27,27l-27.2,27.3C95.9,192.1,94.5,188.5,93.4,184.8  M100.5,200.8l30.4-30.4c0.5-0.5,0.8-1.3,0.8-2c0-0.8-0.3-1.5-0.8-2l-30.1-30.1c1.9-3,4.1-5.8,6.5-8.4l40.5,40.5l-40.9,40.9 C104.5,206.6,102.4,203.8,100.5,200.8 M151.7,197.1c-6.6,0-13-2.3-18.1-6.4l18.1-18.1l18.1,18.1 C164.7,194.8,158.3,197.1,151.7,197.1 M173.8,194.7l7.2,7.2c-8.1,7.1-18.6,11.1-29.4,11.1c-10.8,0-21.3-3.9-29.4-11.1l7.2-7.2 C142.3,205.5,161,205.5,173.8,194.7 M133.5,146c10.6-8.5,25.7-8.5,36.3,0l-18.1,18.1L133.5,146z M151.7,133.8 c-8.1,0-16,2.9-22.2,8.1l-7.2-7.2c16.8-14.7,42-14.7,58.8,0l-7.2,7.2C167.6,136.7,159.8,133.8,151.7,133.8 M111,213.3l7.2-7.2 c19.1,17,47.8,17,66.9,0l7.2,7.2C169.3,234.1,134.1,234.1,111,213.3 M211.3,178.2L211.3,178.2l-9.8-9.8l9.7-9.7 C212.3,165.1,212.4,171.7,211.3,178.2 M209.7,152.1l-14.3,14.3c-1.1,1.1-1.1,2.9,0,4l0,0l14.5,14.5c-1,3.7-2.4,7.3-4.1,10.8 l-27.3-27.3l27-27C207.2,144.8,208.6,148.4,209.7,152.1 M202.5,136.2l-30.1,30.1c-1.1,1.1-1.1,2.9,0,4c0,0,0,0,0,0l30.4,30.4 c-1.9,3-4,5.8-6.4,8.5l-40.9-40.9l40.5-40.5C198.5,130.4,200.6,133.2,202.5,136.2 M192,123.8l-6.8,6.8c-19.1-17-47.8-17-66.9,0 l-6.8-6.8C134.3,103.2,169.1,103.2,192,123.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dsfhfgh",
    d: "M34.2,256.8h8.1c5.1,0,7.4,3,7.4,7.1c0,3.2-1.5,5.5-4.4,6.4l5.3,7.8h-5l-4.8-7.3h-2.4v7.3h-4.2V256.8z  M41.4,267.1c2.6,0,3.9-1.3,3.9-3.3c0-2-1.3-3.3-3.7-3.3h-3.2v6.5H41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dsfhfgh",
    d: "M81.5,256.8h13.6v3.8h-9.4v5.1h7.6v3.7h-7.6v5h10.1v3.8H81.5V256.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dsfhfgh",
    d: "M127,256.8h4.3v17.5h9.4v3.8H127V256.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dsfhfgh",
    d: "M171.6,256.8h4.3v21.3h-4.3V256.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dsfhfgh",
    d: "M208.3,256.8h13.6v3.8h-9.5v5.1h7.6v3.7h-7.6v5h10.1v3.8h-14.2V256.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dsfhfgh",
    d: "M253.8,256.8h14.1v3.8h-10v5.7h8.3v3.8H258v8.1h-4.2V256.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReliefIcon);
export default __webpack_public_path__ + "static/media/relief-icon.e1ec7d4c8f18802d5b0cae2ecab5d21a.svg";
export { ForwardRef as ReactComponent };